export const OUT_MIGRATION_TEMPLATE_ID = "e0eecb61-f3a9-46ff-9d9d-c96b26333b20";
